import { resize } from "./resize";

window.onload = function () {
	resize();
};

export * from "./theme";
export * from "./permission";
